/*    
<summary>
  This functional component "ChangePhone 2" defines the props like initial values and functions for the child form 
  component.
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import toast from "react-hot-toast";
import React, { useEffect } from "react";
import { useStore } from "../../../../contexts/store-provider";
import { formatMessage } from "../../../../translations/format-message";
import { IAddCustomer } from "../../../../models/forms/IAddCustomerManagement";
import ChangeCustomerPhone2Form from "../forms/change-customer-phone2-form";
import { getStoreIdFromLocalStorage, getUserTypeFromLocalStorage } from "../../../../helpers/localstorage-helper";
import userTypeEnum from "../../../../constants/enums/user-type-enum";

interface IProps {
    id: number;
    modalClosed: () => void;
}

const ChangePhone2: React.FC<IProps> = (props) => {
    const { customerManagementStore } = useStore();
    const {
        UpdateCustomerService,
        addUpdateCustomerState,
        resetAddUpdateCustomerState,
        GetCustomerByIdService,
        customerDetail

    } = customerManagementStore;


    const initialValues: IAddCustomer = customerDetail;

    useEffect(() => {
        if (props.id) {
            let userTypeFromLocalStorage = getUserTypeFromLocalStorage();
            GetCustomerByIdService(props.id,
                (userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.SuperAdmin] && userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.HeadQuarter])
                ? getStoreIdFromLocalStorage()
                : null);
        }
    }, []);
    /**
     * The useEffect Hook lets you perform side effects in function component.
     * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while 
     * dependency "changePasswordSuccess" of the useEffect changed.
     */
    useEffect(() => {
        if (addUpdateCustomerState.success) {
              toast.success(formatMessage("updated_success"));
            onModalClosed();
        }
    }, [addUpdateCustomerState.success]);

    /**
     * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while 
     * dependency "changePasswordError" of the useEffect changed.
     */
    useEffect(() => {
        if (addUpdateCustomerState.error) {
            toast.error(formatMessage(addUpdateCustomerState.error));
            resetAddUpdateCustomerState();
        }
    }, [addUpdateCustomerState.error]);

    /**
     * This function changes the user password by provides new password and user Id  to "chagePassword" store funtion that 
     * send the request to Api.
     */
    const onSubmitForm = (values: { Phone2: string }) => {
        const submitData = {
            ...customerDetail,
            Phone2: values.Phone2,
            DmDshs: customerDetail.DmDshs === "true" || customerDetail.DmDshs === true ? true : false,
        };

        UpdateCustomerService(props.id, submitData);
    };



    /**
     * This function closes the pop up modal and reset ChangePassword observables (success, inprogress and error).
     */
    const onModalClosed = () => {
        resetAddUpdateCustomerState();
        props.modalClosed();
    };

    return (
        <ChangeCustomerPhone2Form
            id={props.id}
            initialValues={initialValues}
            submitHandler={onSubmitForm}
            onModalClosed={onModalClosed}
            loading={addUpdateCustomerState.inProgress}
        />
    );
};

export default observer(ChangePhone2);
